export default __webpack_public_path__ + "static/media/bnr7.207f82ef.jpg";